const { createSlice } = require("@reduxjs/toolkit");

const initialState = {
  categories: [], // Liste des catégories
  currentCategorie: null, // Catégorie sélectionnée
  loading: false,
  error: null,
};

const categorieSlice = createSlice({
  name: "categorie",
  initialState,
  reducers: {
    setCategoriesState: (state, { payload }) => {
      state.categories = payload;
    },
    setCategorieState: (state, { payload }) => {
      state.currentCategorie = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
  },
});

// Export des actions corrigées
export const { 
  setCategoriesState, 
  setCategorieState, 
  setLoading, 
  setError 
} = categorieSlice.actions;

export default categorieSlice.reducer;